module.exports = __webpack_public_path__ + "static/media/2aa.6827a6c7.png";